// extracted by mini-css-extract-plugin
export default {"faqHowFindAgent":"faqHowFindAgent_VBZmh","title":"title_AFY6R"};